export default __webpack_public_path__ + "static/media/twitter.f3937207.svg";